var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 200,
    viewBox: "0 0 480 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.n,.q{fill:none;}.b,.c{fill:#fff;}.b{opacity:0.05;}.d{fill:#3f3d56;}.e{fill:#e6e6e6;}.f{fill:#facb1f;}.g{fill:#ccc;}.h{fill:#f1f1f1;}.i{fill:#e5e5e5;}.j{clip-path:url(#a);}.k{fill:#4d4d4d;}.l{fill:#424242;}.m{fill:#fac91f;}.n{stroke:#424242;stroke-miterlimit:10;}.n,.q{stroke-linecap:round;stroke-width:2px;}.o{clip-path:url(#c);}.p{clip-path:url(#d);}.q{stroke:#facb1f;stroke-dasharray:5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.293,
    height: 33.073
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 45.06,
    height: 54.603,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.599,
    height: 27.385,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-252 -229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 480,
    height: 200,
    rx: 10,
    transform: "translate(252 229)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.675 21.188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.143 257.337)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M681.347,274.341h-.036l-20.638,8.813-28.238,12.058a.911.911,0,0,1-.7,0L602.6,283.128l-21.145-8.773-.032-.014h-.036a1.26,1.26,0,0,0-1.259,1.258v54.652a1.26,1.26,0,0,0,1.259,1.258h99.956a1.26,1.26,0,0,0,1.258-1.258V275.6A1.26,1.26,0,0,0,681.347,274.341Z",
    transform: "translate(-550.214 -237.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M683.43,188.91a.179.179,0,0,1-.1-.032l-49.719-34.626a.9.9,0,0,0-1.03,0l-49.361,34.623a.18.18,0,1,1-.207-.294l49.361-34.624a1.262,1.262,0,0,1,1.442,0l49.719,34.626a.18.18,0,0,1-.1.327Z",
    transform: "translate(-552.208 -151.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M435.67,47.555l47.1-34.91,47.461,37.393L485.2,76.735l-24.45-5.573Z",
    transform: "translate(-401.839 -8.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M627.694,432.68h-23.27a1.087,1.087,0,1,1,0-2.174h23.274a1.087,1.087,0,0,1,0,2.174Z",
    transform: "translate(-566.718 -348.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M612.773,416.488h-8.349a1.087,1.087,0,1,1,0-2.174h8.352a1.087,1.087,0,1,1,0,2.174Z",
    transform: "translate(-566.718 -336.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M686.3,221.176a1.36,1.36,0,0,1-.516-.1l-29.05-12.054V171.29a1.26,1.26,0,0,1,1.258-1.258h55.731a1.26,1.26,0,0,1,1.258,1.258v37.757l-.055.023-28.1,12a1.369,1.369,0,0,1-.531.107Z",
    transform: "translate(-604.699 -163.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M686.074,221.044a1.451,1.451,0,0,1-.55-.108l-29.106-12.077v-37.79a1.35,1.35,0,0,1,1.348-1.348H713.5a1.35,1.35,0,0,1,1.348,1.348v37.816l-28.2,12.045A1.458,1.458,0,0,1,686.074,221.044Zm-29.3-12.425L685.661,220.6a1.1,1.1,0,0,0,.839,0l27.985-11.951V171.069a.99.99,0,0,0-.989-.989H657.766a.99.99,0,0,0-.989.989Z",
    transform: "translate(-604.477 -162.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M680.413,274.341h-.036l-20.638,8.813L631.5,295.211a.911.911,0,0,1-.7,0l-29.133-12.086-21.145-8.773-.032-.014h-.036A1.26,1.26,0,0,0,579.2,275.6v54.652a1.26,1.26,0,0,0,1.259,1.258h99.956a1.26,1.26,0,0,0,1.259-1.258V275.6A1.26,1.26,0,0,0,680.413,274.341Zm.9,55.911a.9.9,0,0,1-.9.9H580.457a.9.9,0,0,1-.9-.9V275.6a.9.9,0,0,1,.865-.9l21.248,8.816,28.994,12.031a1.28,1.28,0,0,0,.978-.005l28.1-12,20.71-8.843a.9.9,0,0,1,.863.9Z",
    transform: "translate(-549.55 -237.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M691.21,211.8H671.435a1.438,1.438,0,1,1,0-2.876H691.21a1.438,1.438,0,1,1,0,2.876Z",
    transform: "translate(-614.135 -190.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M680.963,190.627h-9.528a1.438,1.438,0,0,1,0-2.876h9.528a1.438,1.438,0,1,1,0,2.876Z",
    transform: "translate(-614.135 -175.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M730.886,261.619h-30.2a1.438,1.438,0,0,1,0-2.876h30.2a1.438,1.438,0,0,1,0,2.876Z",
    transform: "translate(-634.94 -226.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M730.886,284.66h-30.2a1.438,1.438,0,0,1,0-2.876h30.2a1.438,1.438,0,1,1,0,2.876Z",
    transform: "translate(-634.94 -242.662)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 13.676,
    cy: 13.676,
    r: 13.676,
    transform: "translate(116.63 23.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M755.254,121.456l-4.093-5.263,2.38-1.851,1.938,2.492,6.547-6.911L764.216,112Z",
    transform: "translate(-626.251 -78.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M479.63,193.348a.577.577,0,0,0-.865.575l.446,3.269a.376.376,0,0,1-.01.144.353.353,0,0,1-.069.126l-2.5,2.957a.564.564,0,0,0-.037.7l0,0a.563.563,0,0,0,.659.217l1.8-.612a.347.347,0,0,1,.349.078.335.335,0,0,1,.107.247l.07,6.423a.573.573,0,0,0,.252.47.579.579,0,0,0,.529.062l13.455-5.146a.577.577,0,0,0,.089-1.035l-.183-.109Zm-.638.543a.347.347,0,0,1,.52-.344l14.1,8.364.188.111a.347.347,0,0,1-.053.621l-13.455,5.146a.346.346,0,0,1-.469-.319l-.07-6.423a.553.553,0,0,0-.032-.187l13.7,1.574a.231.231,0,0,0,.138-.432.2.2,0,0,0-.036-.016l-14.077-4.7a.568.568,0,0,0,0-.128l-.446-3.269Z",
    transform: "translate(-476.496 -179.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M479.63,193.348a.577.577,0,0,0-.865.575l.446,3.269a.376.376,0,0,1-.01.144.353.353,0,0,1-.069.126l-2.5,2.957a.564.564,0,0,0-.037.7l0,0a.563.563,0,0,0,.659.217l1.8-.612a.347.347,0,0,1,.349.078.335.335,0,0,1,.107.247l.07,6.423a.573.573,0,0,0,.252.47.579.579,0,0,0,.529.062l13.455-5.146a.577.577,0,0,0,.089-1.035l-.183-.109Zm-.638.543a.347.347,0,0,1,.52-.344l14.1,8.364.188.111a.347.347,0,0,1-.053.621l-13.455,5.146a.346.346,0,0,1-.469-.319l-.07-6.423a.553.553,0,0,0-.032-.186.561.561,0,0,0-.148-.226c-.009-.009-.019-.018-.029-.026h0a.575.575,0,0,0-.551-.1l-1.8.613a.336.336,0,0,1-.4-.132v0a.335.335,0,0,1,.022-.418l2.5-2.957a.541.541,0,0,0,.069-.1h0a.551.551,0,0,0,.044-.109.532.532,0,0,0,.02-.112.568.568,0,0,0,0-.128l-.446-3.269Z",
    transform: "translate(-476.496 -179.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M486.391,207.149l14.076,4.7a.207.207,0,0,1,.036.016.231.231,0,0,1-.138.432l-13.7-1.574-.242-.028.027-.229.037,0h0l13.9,1.6-14.065-4.7h0l-.061-.021.073-.219Z",
    transform: "translate(-483.444 -189.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M995.234,146.349l-14.1,8.367-.183.109a.577.577,0,0,0,.088,1.035l13.455,5.146a.576.576,0,0,0,.781-.532l.071-6.423a.335.335,0,0,1,.107-.247.347.347,0,0,1,.349-.078l1.8.612a.563.563,0,0,0,.659-.217l0,0a.564.564,0,0,0-.036-.7l-2.5-2.957a.351.351,0,0,1-.068-.126.375.375,0,0,1-.01-.144l.446-3.269a.577.577,0,0,0-.866-.575Zm.638.543-.446,3.269a.572.572,0,0,0,0,.128l-14.077,4.7a.2.2,0,0,0-.036.016.231.231,0,0,0,.138.432l13.7-1.574a.555.555,0,0,0-.032.186l-.07,6.423a.346.346,0,0,1-.469.319l-13.455-5.146a.347.347,0,0,1-.053-.621l.188-.111,14.1-8.364a.347.347,0,0,1,.52.344Z",
    transform: "translate(-835.118 -146.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M995.234,146.349l-14.1,8.367-.183.109a.577.577,0,0,0,.088,1.035l13.455,5.146a.576.576,0,0,0,.781-.532l.071-6.423a.335.335,0,0,1,.107-.247.347.347,0,0,1,.349-.078l1.8.612a.563.563,0,0,0,.659-.217l0,0a.564.564,0,0,0-.036-.7l-2.5-2.957a.351.351,0,0,1-.068-.126.375.375,0,0,1-.01-.144l.446-3.269a.577.577,0,0,0-.866-.575Zm.638.543-.446,3.269a.564.564,0,0,0,0,.128.532.532,0,0,0,.02.112.547.547,0,0,0,.044.109h0a.551.551,0,0,0,.069.1l2.5,2.957a.335.335,0,0,1,.022.418v0a.335.335,0,0,1-.4.132l-1.8-.613a.575.575,0,0,0-.551.1h0l-.029.026a.562.562,0,0,0-.148.226.552.552,0,0,0-.032.186l-.07,6.423a.346.346,0,0,1-.469.319l-13.455-5.146a.347.347,0,0,1-.053-.621l.188-.111,14.1-8.364a.347.347,0,0,1,.52.344Z",
    transform: "translate(-835.118 -146.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M996.758,160.131l.073.219-.061.021h0l-14.065,4.7,13.9-1.6h0l.037,0,.027.229-.242.028-13.7,1.574a.231.231,0,0,1-.138-.432.2.2,0,0,1,.036-.016l14.077-4.7Z",
    transform: "translate(-836.402 -156.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M612.368,532.745a.577.577,0,0,0,.023,1.039l3,1.37a.375.375,0,0,1,.117.085.352.352,0,0,1,.07.125l1.165,3.69a.564.564,0,0,0,.569.4h0a.563.563,0,0,0,.536-.441l.446-1.851a.346.346,0,0,1,.253-.253.335.335,0,0,1,.266.041l5.466,3.373a.576.576,0,0,0,.867-.376l2.841-14.122a.577.577,0,0,0-.828-.628l-.19.1Zm.118.829a.347.347,0,0,1-.013-.624l14.6-7.445.194-.1a.347.347,0,0,1,.5.376l-2.841,14.122a.346.346,0,0,1-.52.226l-5.466-3.373a.553.553,0,0,0-.175-.072l8.651-10.737a.231.231,0,0,0-.291-.348.2.2,0,0,0-.033.022L615.6,535.01a.571.571,0,0,0-.11-.065l-3-1.37Z",
    transform: "translate(-572.92 -415.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M612.368,532.745a.577.577,0,0,0,.023,1.039l3,1.37a.375.375,0,0,1,.117.085.352.352,0,0,1,.07.125l1.165,3.69a.564.564,0,0,0,.569.4h0a.563.563,0,0,0,.536-.441l.446-1.851a.346.346,0,0,1,.253-.253.335.335,0,0,1,.266.041l5.466,3.373a.576.576,0,0,0,.867-.376l2.841-14.122a.577.577,0,0,0-.828-.628l-.19.1Zm.118.829a.347.347,0,0,1-.013-.624l14.6-7.445.194-.1a.347.347,0,0,1,.5.376l-2.841,14.122a.346.346,0,0,1-.52.226l-5.466-3.373a.553.553,0,0,0-.175-.072.561.561,0,0,0-.27,0l-.038.011h0a.575.575,0,0,0-.38.411l-.446,1.852a.336.336,0,0,1-.323.264h0a.335.335,0,0,1-.341-.242L615.8,535.3a.528.528,0,0,0-.049-.112h0a.545.545,0,0,0-.068-.1.537.537,0,0,0-.084-.077.58.58,0,0,0-.11-.065l-3-1.37Z",
    transform: "translate(-572.92 -415.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M624.222,536.078l11.494-9.387a.222.222,0,0,1,.033-.022.231.231,0,0,1,.291.348l-8.651,10.737-.153.19-.179-.145.023-.03h0l8.778-10.9-11.486,9.378h0l-.05.04-.146-.179Z",
    transform: "translate(-581.544 -416.831)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(344.306 231.72) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2.478,4.581a1.082,1.082,0,0,1-.946-.546L.148,1.639a1.081,1.081,0,0,1,0-1.093A1.082,1.082,0,0,1,1.094,0H3.861a1.082,1.082,0,0,1,.946.546,1.081,1.081,0,0,1,0,1.093l-1.383,2.4a1.082,1.082,0,0,1-.946.546",
    transform: "translate(11.179 27.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4.526,1.329a.428.428,0,0,1,.371.642l-1.383,2.4a.428.428,0,0,1-.742,0l-1.383-2.4a.428.428,0,0,1,.371-.642ZM4.526,0H1.76A1.757,1.757,0,0,0,.238,2.636l1.383,2.4a1.757,1.757,0,0,0,3.043,0l1.383-2.4A1.757,1.757,0,0,0,4.526,0",
    transform: "translate(10.514 27.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M7.2,15.822c-3.967,0-7.2-3.549-7.2-7.911S3.228,0,7.2,0s7.2,3.549,7.2,7.911-3.228,7.911-7.2,7.911",
    transform: "translate(6.462 13.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M15.342,5.944A7.967,7.967,0,0,0,7.859,0,7.966,7.966,0,0,0,.377,5.944,9.258,9.258,0,0,0,0,8.575q0,.465.045.917C.464,13.8,3.8,17.15,7.859,17.15s7.4-3.354,7.815-7.659q.044-.452.045-.917a9.258,9.258,0,0,0-.377-2.63M7.859,15.821a6.652,6.652,0,0,1-6.217-5.031A8.021,8.021,0,0,1,1.5,6.907,6.724,6.724,0,0,1,7.859,1.329a6.724,6.724,0,0,1,6.356,5.579,8.016,8.016,0,0,1-.138,3.883,6.652,6.652,0,0,1-6.218,5.031",
    transform: "translate(5.797 13.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M15.719,2.63q0,.465-.045.917a9.9,9.9,0,0,1-1.6,1.3A11.153,11.153,0,0,1,7.859,6.6,11.146,11.146,0,0,1,1.642,4.846a9.853,9.853,0,0,1-1.6-1.3Q0,3.095,0,2.63A9.258,9.258,0,0,1,.377,0,7.58,7.58,0,0,0,1.5.963,10.767,10.767,0,0,0,7.859,2.711,10.779,10.779,0,0,0,14.215.964,7.645,7.645,0,0,0,15.342,0a9.258,9.258,0,0,1,.377,2.63",
    transform: "translate(5.797 19.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.47,10.789A4.411,4.411,0,0,1,.454,8.664C-.749,6.449.523,3.425,3.29,1.921,5.67.628,7.462,0,8.77,0a1.951,1.951,0,0,1,1.912,1.009,6.657,6.657,0,0,1-.019,4.728A7.246,7.246,0,0,1,7.654,9.953a6.707,6.707,0,0,1-3.184.836",
    transform: "translate(0.664 13.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M9.434,0V1.329c.851,0,1.141.318,1.328.661A6.1,6.1,0,0,1,10.692,6.2,6.589,6.589,0,0,1,8,10.034a6.042,6.042,0,0,1-2.866.755A3.761,3.761,0,0,1,1.7,9.011,3.479,3.479,0,0,1,1.639,6,5.765,5.765,0,0,1,4.271,3.17,12.345,12.345,0,0,1,9.433,1.329Zm0,0C7.718,0,5.54.968,3.637,2,.543,3.683-.847,7.1.534,9.645a5.071,5.071,0,0,0,4.6,2.473,7.369,7.369,0,0,0,3.5-.916c3.094-1.681,4.674-7.305,3.294-9.846A2.616,2.616,0,0,0,9.433,0",
    transform: "translate(0 12.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.63,10.789a6.707,6.707,0,0,1-3.184-.836A7.246,7.246,0,0,1,.438,5.737,6.657,6.657,0,0,1,.419,1.009,1.951,1.951,0,0,1,2.331,0c1.307,0,3.1.628,5.479,1.921,2.767,1.5,4.04,4.528,2.837,6.743A4.411,4.411,0,0,1,6.63,10.789Z",
    transform: "translate(15.529 13.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M3,1.329A12.343,12.343,0,0,1,8.16,3.17,5.764,5.764,0,0,1,10.793,6a3.479,3.479,0,0,1-.063,3.01A3.761,3.761,0,0,1,7.3,10.789a6.042,6.042,0,0,1-2.866-.755A6.589,6.589,0,0,1,1.739,6.2,6.1,6.1,0,0,1,1.67,1.99c.187-.344.477-.661,1.328-.661M3,0A2.616,2.616,0,0,0,.5,1.356C-.877,3.9.7,9.521,3.8,11.2a7.369,7.369,0,0,0,3.5.916,5.071,5.071,0,0,0,4.6-2.473C13.278,7.1,11.889,3.683,8.795,2,6.891.968,4.714,0,3,0",
    transform: "translate(14.861 12.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M5.251,6.242A8.024,8.024,0,0,0,0,0",
    transform: "translate(6.68 1.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,6.242A8.024,8.024,0,0,1,5.251,0",
    transform: "translate(15.383 1.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.726,1.453A.726.726,0,1,1,1.453.726a.727.727,0,0,1-.726.726",
    transform: "translate(5.228 0.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.391,1.329a.062.062,0,1,1-.062.062.062.062,0,0,1,.062-.062M1.391,0A1.391,1.391,0,1,0,2.782,1.391,1.391,1.391,0,0,0,1.391,0",
    transform: "translate(4.563 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.726,1.453A.726.726,0,1,1,1.453.726a.727.727,0,0,1-.726.726",
    transform: "translate(20.633 0.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.391,1.329a.062.062,0,1,1-.062.062.062.062,0,0,1,.062-.062M1.391,0A1.391,1.391,0,1,0,2.782,1.391,1.391,1.391,0,0,0,1.391,0",
    transform: "translate(19.968 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M5.711,9.141C2.562,9.141,0,7.091,0,4.57S2.562,0,5.711,0s5.711,2.05,5.711,4.57-2.562,4.57-5.711,4.57",
    transform: "translate(7.945 7.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M6.376,1.329A5.764,5.764,0,0,1,10.041,2.56a3.479,3.479,0,0,1,1.382,2.675A3.479,3.479,0,0,1,10.041,7.91,5.764,5.764,0,0,1,6.376,9.141,5.764,5.764,0,0,1,2.711,7.91,3.479,3.479,0,0,1,1.329,5.235,3.479,3.479,0,0,1,2.711,2.56,5.764,5.764,0,0,1,6.376,1.329M6.376,0C2.854,0,0,2.344,0,5.235S2.854,10.47,6.376,10.47s6.376-2.344,6.376-5.235S9.9,0,6.376,0",
    transform: "translate(7.281 6.907)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(0.629, -0.777, 0.777, 0.629, 327.089, 341.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2.478,4.581a1.082,1.082,0,0,1-.946-.546L.148,1.639a1.081,1.081,0,0,1,0-1.093A1.082,1.082,0,0,1,1.094,0H3.861a1.082,1.082,0,0,1,.946.546,1.081,1.081,0,0,1,0,1.093l-1.383,2.4a1.082,1.082,0,0,1-.946.546",
    transform: "translate(11.179 27.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4.526,1.329a.428.428,0,0,1,.371.642l-1.383,2.4a.428.428,0,0,1-.742,0l-1.383-2.4a.428.428,0,0,1,.371-.642ZM4.526,0H1.76A1.757,1.757,0,0,0,.238,2.636l1.383,2.4a1.757,1.757,0,0,0,3.043,0l1.383-2.4A1.757,1.757,0,0,0,4.526,0",
    transform: "translate(10.514 27.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M7.2,15.822c-3.967,0-7.2-3.549-7.2-7.911S3.228,0,7.2,0s7.2,3.549,7.2,7.911-3.228,7.911-7.2,7.911",
    transform: "translate(6.462 13.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M15.342,5.944A7.967,7.967,0,0,0,7.859,0,7.966,7.966,0,0,0,.377,5.944,9.258,9.258,0,0,0,0,8.575q0,.465.045.917C.464,13.8,3.8,17.15,7.859,17.15s7.4-3.354,7.815-7.659q.044-.452.045-.917a9.258,9.258,0,0,0-.377-2.63M7.859,15.821a6.652,6.652,0,0,1-6.217-5.031A8.021,8.021,0,0,1,1.5,6.907,6.724,6.724,0,0,1,7.859,1.329a6.724,6.724,0,0,1,6.356,5.579,8.016,8.016,0,0,1-.138,3.883,6.652,6.652,0,0,1-6.218,5.031",
    transform: "translate(5.797 13.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M15.719,2.63q0,.465-.045.917a9.9,9.9,0,0,1-1.6,1.3A11.153,11.153,0,0,1,7.859,6.6,11.146,11.146,0,0,1,1.642,4.846a9.853,9.853,0,0,1-1.6-1.3Q0,3.095,0,2.63A9.258,9.258,0,0,1,.377,0,7.58,7.58,0,0,0,1.5.963,10.767,10.767,0,0,0,7.859,2.711,10.779,10.779,0,0,0,14.215.964,7.645,7.645,0,0,0,15.342,0a9.258,9.258,0,0,1,.377,2.63",
    transform: "translate(5.797 19.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.47,10.789A4.411,4.411,0,0,1,.454,8.664C-.749,6.449.523,3.425,3.29,1.921,5.67.628,7.462,0,8.77,0a1.951,1.951,0,0,1,1.912,1.009,6.657,6.657,0,0,1-.019,4.728A7.246,7.246,0,0,1,7.654,9.953a6.707,6.707,0,0,1-3.184.836",
    transform: "translate(0.664 13.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M9.434,0V1.329c.851,0,1.141.318,1.328.661A6.1,6.1,0,0,1,10.692,6.2,6.589,6.589,0,0,1,8,10.034a6.042,6.042,0,0,1-2.866.755A3.761,3.761,0,0,1,1.7,9.011,3.479,3.479,0,0,1,1.639,6,5.765,5.765,0,0,1,4.271,3.17,12.345,12.345,0,0,1,9.433,1.329Zm0,0C7.718,0,5.54.968,3.637,2,.543,3.683-.847,7.1.534,9.645a5.071,5.071,0,0,0,4.6,2.473,7.369,7.369,0,0,0,3.5-.916c3.094-1.681,4.674-7.305,3.294-9.846A2.616,2.616,0,0,0,9.433,0",
    transform: "translate(0 12.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.63,10.789a6.707,6.707,0,0,1-3.184-.836A7.246,7.246,0,0,1,.438,5.737,6.657,6.657,0,0,1,.419,1.009,1.951,1.951,0,0,1,2.331,0c1.307,0,3.1.628,5.479,1.921,2.767,1.5,4.04,4.528,2.837,6.743A4.411,4.411,0,0,1,6.63,10.789Z",
    transform: "translate(15.529 13.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M3,1.329A12.343,12.343,0,0,1,8.16,3.17,5.764,5.764,0,0,1,10.793,6a3.479,3.479,0,0,1-.063,3.01A3.761,3.761,0,0,1,7.3,10.789a6.042,6.042,0,0,1-2.866-.755A6.589,6.589,0,0,1,1.739,6.2,6.1,6.1,0,0,1,1.67,1.99c.187-.344.477-.661,1.328-.661M3,0A2.616,2.616,0,0,0,.5,1.356C-.877,3.9.7,9.521,3.8,11.2a7.369,7.369,0,0,0,3.5.916,5.071,5.071,0,0,0,4.6-2.473C13.278,7.1,11.889,3.683,8.795,2,6.891.968,4.714,0,3,0",
    transform: "translate(14.861 12.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M5.251,6.242A8.024,8.024,0,0,0,0,0",
    transform: "translate(6.68 1.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,6.242A8.024,8.024,0,0,1,5.251,0",
    transform: "translate(15.383 1.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.726,1.453A.726.726,0,1,1,1.453.726a.727.727,0,0,1-.726.726",
    transform: "translate(5.228 0.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.391,1.329a.062.062,0,1,1-.062.062.062.062,0,0,1,.062-.062M1.391,0A1.391,1.391,0,1,0,2.782,1.391,1.391,1.391,0,0,0,1.391,0",
    transform: "translate(4.563 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.726,1.453A.726.726,0,1,1,1.453.726a.727.727,0,0,1-.726.726",
    transform: "translate(20.633 0.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.391,1.329a.062.062,0,1,1-.062.062.062.062,0,0,1,.062-.062M1.391,0A1.391,1.391,0,1,0,2.782,1.391,1.391,1.391,0,0,0,1.391,0",
    transform: "translate(19.968 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M5.711,9.141C2.562,9.141,0,7.091,0,4.57S2.562,0,5.711,0s5.711,2.05,5.711,4.57-2.562,4.57-5.711,4.57",
    transform: "translate(7.945 7.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M6.376,1.329A5.764,5.764,0,0,1,10.041,2.56a3.479,3.479,0,0,1,1.382,2.675A3.479,3.479,0,0,1,10.041,7.91,5.764,5.764,0,0,1,6.376,9.141,5.764,5.764,0,0,1,2.711,7.91,3.479,3.479,0,0,1,1.329,5.235,3.479,3.479,0,0,1,2.711,2.56,5.764,5.764,0,0,1,6.376,1.329M6.376,0C2.854,0,0,2.344,0,5.235S2.854,10.47,6.376,10.47s6.376-2.344,6.376-5.235S9.9,0,6.376,0",
    transform: "translate(7.281 6.907)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(592.259 396.728) rotate(-150)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M4.09,0A1.786,1.786,0,0,0,2.528.9L.245,4.857A1.8,1.8,0,0,0,1.807,7.563H6.374A1.8,1.8,0,0,0,7.936,4.857L5.653.9A1.786,1.786,0,0,0,4.09,0",
    transform: "translate(18.457 1.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M7.473,7.563A.707.707,0,0,0,8.085,6.5L5.8,2.547a.707.707,0,0,0-1.224,0L2.293,6.5a.707.707,0,0,0,.612,1.06Zm0,2.194H2.905A2.9,2.9,0,0,1,.393,5.406L2.677,1.45a2.9,2.9,0,0,1,5.024,0L9.985,5.406A2.9,2.9,0,0,1,7.473,9.757",
    transform: "translate(17.358 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M11.879,0C5.329,0,0,5.859,0,13.061S5.329,26.122,11.879,26.122s11.879-5.859,11.879-13.061S18.429,0,11.879,0",
    transform: "translate(10.668 5.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M25.329,18.5c-1.679,5.694-6.577,9.814-12.354,9.814S2.3,24.2.623,18.5A15.285,15.285,0,0,1,0,14.158q0-.767.074-1.514C.766,5.537,6.278,0,12.975,0s12.211,5.537,12.9,12.644q.073.747.074,1.514a15.285,15.285,0,0,1-.623,4.343M12.975,2.194C8.18,2.194,4.106,5.686,2.71,10.5a13.242,13.242,0,0,0-.228,6.412c1.122,5.274,5.4,9.21,10.493,9.21s9.372-3.937,10.494-9.212a13.235,13.235,0,0,0-.228-6.41c-1.4-4.813-5.47-8.305-10.266-8.305",
    transform: "translate(9.571 4.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M25.952,6.547q0-.767-.074-1.514a16.342,16.342,0,0,0-2.636-2.145A18.413,18.413,0,0,0,12.975,0,18.4,18.4,0,0,0,2.71,2.888,16.267,16.267,0,0,0,.074,5.033Q0,5.78,0,6.547a15.285,15.285,0,0,0,.623,4.343A12.517,12.517,0,0,1,2.483,9.3C4.707,7.737,8.045,6.413,12.975,6.413S21.245,7.737,23.47,9.3a12.621,12.621,0,0,1,1.86,1.592,15.285,15.285,0,0,0,.623-4.343",
    transform: "translate(9.571 12.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.381,0A7.282,7.282,0,0,0,.749,3.509c-1.986,3.656.115,8.65,4.683,11.132,3.929,2.134,6.888,3.172,9.046,3.172a3.221,3.221,0,0,0,3.157-1.665c.934-1.718.921-4.783-.032-7.806C16.589,5.12,14.732,2.518,12.637,1.38A11.074,11.074,0,0,0,7.381,0",
    transform: "translate(1.096 14.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M15.575,20.007V17.813c1.405,0,1.884-.525,2.192-1.092.786-1.447.74-4.241-.114-6.953-.931-2.956-2.593-5.321-4.444-6.327A9.975,9.975,0,0,0,8.477,2.194,6.209,6.209,0,0,0,2.809,5.13a5.744,5.744,0,0,0-.1,4.969,9.517,9.517,0,0,0,4.346,4.675c3.711,2.016,6.579,3.039,8.523,3.039Zm0,0c-2.832,0-6.427-1.6-9.57-3.305C.9,13.927-1.4,8.277.881,4.082A8.372,8.372,0,0,1,8.477,0a12.166,12.166,0,0,1,5.78,1.513c5.108,2.775,7.717,12.061,5.439,16.255a4.318,4.318,0,0,1-4.121,2.239",
    transform: "translate(0 13.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.946,0A11.074,11.074,0,0,0,5.69,1.38C3.595,2.518,1.738,5.12.723,8.341c-.953,3.024-.965,6.088-.031,7.806a3.221,3.221,0,0,0,3.157,1.665c2.158,0,5.117-1.037,9.046-3.172,4.568-2.482,6.669-7.476,4.683-11.132A7.282,7.282,0,0,0,10.946,0Z",
    transform: "translate(25.638 14.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M4.951,17.813c1.943,0,4.811-1.022,8.522-3.039A9.517,9.517,0,0,0,17.819,10.1a5.744,5.744,0,0,0-.1-4.969,6.209,6.209,0,0,0-5.668-2.936A9.976,9.976,0,0,0,7.316,3.441C5.464,4.447,3.8,6.812,2.872,9.768c-.854,2.712-.9,5.506-.114,6.953.308.567.787,1.092,2.193,1.092m0,2.194A4.319,4.319,0,0,1,.83,17.768c-2.279-4.194.33-13.48,5.439-16.255A12.165,12.165,0,0,1,12.048,0a8.372,8.372,0,0,1,7.6,4.082c2.279,4.194-.015,9.844-5.123,12.62-3.143,1.707-6.738,3.305-9.57,3.305",
    transform: "translate(24.535 13.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M8.669,0A13.247,13.247,0,0,1,0,10.306",
    transform: "translate(11.028 41.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,0A13.247,13.247,0,0,0,8.669,10.306",
    transform: "translate(25.397 41.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1.2,0A1.2,1.2,0,1,0,2.4,1.2,1.2,1.2,0,0,0,1.2,0",
    transform: "translate(8.631 51.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2.3,2.4a.1.1,0,1,0-.1-.1.1.1,0,0,0,.1.1m0,2.194a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3",
    transform: "translate(7.534 50.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1.2,0A1.2,1.2,0,1,0,2.4,1.2,1.2,1.2,0,0,0,1.2,0",
    transform: "translate(34.065 51.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2.3,2.4a.1.1,0,1,0-.1-.1.1.1,0,0,0,.1.1m0,2.194a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3",
    transform: "translate(32.968 50.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M9.429,0C4.23,0,0,3.385,0,7.546s4.23,7.546,9.429,7.546,9.429-3.385,9.429-7.546S14.629,0,9.429,0",
    transform: "translate(13.118 27.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M10.526,15.092a9.517,9.517,0,0,0,6.051-2.033,5.743,5.743,0,0,0,2.281-4.416,5.743,5.743,0,0,0-2.281-4.416,9.517,9.517,0,0,0-6.051-2.033A9.517,9.517,0,0,0,4.475,4.227,5.743,5.743,0,0,0,2.194,8.643a5.743,5.743,0,0,0,2.281,4.416,9.517,9.517,0,0,0,6.051,2.033m0,2.194C4.713,17.286,0,13.416,0,8.643S4.713,0,10.526,0,21.052,3.869,21.052,8.643s-4.713,8.643-10.526,8.643",
    transform: "translate(12.021 25.914)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(566.54 274.846) rotate(-150)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2.051,0a.9.9,0,0,0-.783.452L.123,2.436A.9.9,0,0,0,.906,3.793H3.2A.9.9,0,0,0,3.98,2.436L2.835.452A.9.9,0,0,0,2.051,0",
    transform: "translate(9.257 0.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M3.748,3.793a.354.354,0,0,0,.307-.532L2.909,1.278a.355.355,0,0,0-.614,0L1.15,3.261a.354.354,0,0,0,.307.532Zm0,1.1H1.457A1.455,1.455,0,0,1,.2,2.711L1.342.727a1.455,1.455,0,0,1,2.52,0L5.008,2.711a1.455,1.455,0,0,1-1.26,2.182",
    transform: "translate(8.706 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M5.958,0C2.673,0,0,2.939,0,6.55S2.673,13.1,5.958,13.1s5.958-2.938,5.958-6.55S9.243,0,5.958,0",
    transform: "translate(5.35 2.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M12.7,9.279a6.6,6.6,0,0,1-6.2,4.922,6.6,6.6,0,0,1-6.2-4.922A7.666,7.666,0,0,1,0,7.1q0-.385.037-.759A6.748,6.748,0,0,1,6.507,0a6.749,6.749,0,0,1,6.471,6.342q.037.375.037.759A7.666,7.666,0,0,1,12.7,9.279M6.507,1.1A5.508,5.508,0,0,0,1.359,5.266a6.641,6.641,0,0,0-.114,3.216A5.567,5.567,0,0,0,6.507,13.1a5.568,5.568,0,0,0,5.263-4.62,6.638,6.638,0,0,0-.114-3.215A5.508,5.508,0,0,0,6.507,1.1",
    transform: "translate(4.8 2.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M13.016,3.283q0-.385-.037-.759a8.2,8.2,0,0,0-1.322-1.076A9.234,9.234,0,0,0,6.507,0,9.229,9.229,0,0,0,1.359,1.448,8.159,8.159,0,0,0,.037,2.524Q0,2.9,0,3.283A7.666,7.666,0,0,0,.312,5.461a6.277,6.277,0,0,1,.933-.8A8.916,8.916,0,0,1,6.507,3.216a8.925,8.925,0,0,1,5.263,1.447,6.33,6.33,0,0,1,.933.8,7.666,7.666,0,0,0,.312-2.178",
    transform: "translate(4.8 6.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.7,0A3.652,3.652,0,0,0,.376,1.76c-1,1.834.057,4.338,2.349,5.583A10.526,10.526,0,0,0,7.261,8.934,1.616,1.616,0,0,0,8.844,8.1a5.512,5.512,0,0,0-.016-3.915A6,6,0,0,0,6.338.692,5.554,5.554,0,0,0,3.7,0",
    transform: "translate(0.55 7.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M7.811,10.034v-1.1c.7,0,.945-.263,1.1-.548A5.053,5.053,0,0,0,8.853,4.9,5.456,5.456,0,0,0,6.625,1.726,5,5,0,0,0,4.251,1.1,3.114,3.114,0,0,0,1.409,2.573a2.881,2.881,0,0,0-.052,2.492A4.773,4.773,0,0,0,3.537,7.41,10.222,10.222,0,0,0,7.811,8.934Zm0,0a11.432,11.432,0,0,1-4.8-1.658C.449,6.985-.7,4.151.442,2.047A4.2,4.2,0,0,1,4.251,0a6.1,6.1,0,0,1,2.9.759c2.562,1.392,3.87,6.049,2.728,8.152a2.166,2.166,0,0,1-2.067,1.123",
    transform: "translate(0 6.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.49,0A5.554,5.554,0,0,0,2.854.692,6,6,0,0,0,.363,4.183,5.512,5.512,0,0,0,.347,8.1a1.615,1.615,0,0,0,1.583.835A10.527,10.527,0,0,0,6.467,7.343C8.758,6.1,9.812,3.593,8.816,1.76A3.652,3.652,0,0,0,5.49,0Z",
    transform: "translate(12.858 7.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2.483,8.934A10.22,10.22,0,0,0,6.757,7.41a4.773,4.773,0,0,0,2.18-2.345,2.881,2.881,0,0,0-.052-2.492A3.114,3.114,0,0,0,6.043,1.1a5,5,0,0,0-2.374.625A5.456,5.456,0,0,0,1.44,4.9a5.053,5.053,0,0,0-.057,3.487c.155.284.395.548,1.1.548m0,1.1A2.166,2.166,0,0,1,.416,8.911C-.727,6.808.582,2.151,3.144.759A6.1,6.1,0,0,1,6.043,0,4.2,4.2,0,0,1,9.852,2.047c1.143,2.1-.008,4.937-2.57,6.329a11.429,11.429,0,0,1-4.8,1.658",
    transform: "translate(12.305 6.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M4.348,0A6.644,6.644,0,0,1,0,5.169",
    transform: "translate(5.531 20.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,0A6.644,6.644,0,0,0,4.348,5.169",
    transform: "translate(12.738 20.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.6,0a.6.6,0,1,0,.6.6A.6.6,0,0,0,.6,0",
    transform: "translate(4.329 25.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.152,1.2A.051.051,0,1,0,1.1,1.152a.051.051,0,0,0,.051.051m0,1.1A1.152,1.152,0,1,1,2.3,1.152,1.152,1.152,0,0,1,1.152,2.3",
    transform: "translate(3.779 25.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.6,0a.6.6,0,1,0,.6.6A.6.6,0,0,0,.6,0",
    transform: "translate(17.084 25.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.152,1.2A.051.051,0,1,0,1.1,1.152a.051.051,0,0,0,.051.051m0,1.1A1.152,1.152,0,1,1,2.3,1.152,1.152,1.152,0,0,1,1.152,2.3",
    transform: "translate(16.534 25.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M4.729,0C2.121,0,0,1.7,0,3.784S2.121,7.569,4.729,7.569s4.729-1.7,4.729-3.784S7.337,0,4.729,0",
    transform: "translate(6.579 13.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M5.279,7.569a4.773,4.773,0,0,0,3.035-1.02A2.88,2.88,0,0,0,9.458,4.335,2.88,2.88,0,0,0,8.314,2.12,4.773,4.773,0,0,0,5.279,1.1,4.773,4.773,0,0,0,2.245,2.12,2.88,2.88,0,0,0,1.1,4.335,2.88,2.88,0,0,0,2.245,6.549a4.773,4.773,0,0,0,3.035,1.02m0,1.1C2.364,8.669,0,6.729,0,4.335S2.364,0,5.279,0s5.279,1.941,5.279,4.335S8.195,8.669,5.279,8.669",
    transform: "translate(6.029 12.997)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M380.215,4184.516s-.96,37.162,39.444,46.416",
    transform: "translate(-6.543 -3926.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M369.854,4295.7s3.16,25.28,30.7,27.086,13.317-18.51,5.417-12.641,9.932,21.9,33.406,22.347,37.328-20.576,33.788-33.788",
    transform: "translate(-5.267 -3940.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M583.181,4202.059s-7,6.094-7.449,21.443-6.094,20.09-17.38,23.7",
    transform: "translate(-28.483 -3928.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M589.911,4329.933s-11.963,10.383-41.532-1.579-37.921,1.354-35.889,7.9,27.764-2.032-10.835-37.019",
    transform: "translate(-21.5 -3940.726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIllus);
export default __webpack_public_path__ + "static/media/invite-illus.c16d48695fdd1c1715c8996143692a76.svg";
export { ForwardRef as ReactComponent };